import { LocationPicker } from '../location/LocationPicker';

export interface Location {
  name: string;
  href: string | null;
}

interface LocationSectionProps {
  locations: Location[];
  title: string;
}

export function LocationSection({ locations, title }: LocationSectionProps) {
  return locations.length > 0 ? (
    <LocationPicker title={title} locations={locations} />
  ) : null;
}
